<div class="container-filter" (click)="flagInput = false">
  <!-- BUSCA SUPERIOR -->
  <div class="dnd-filter">
    <div class="dnd-element">
      <div class="element-column">
        <app-input-search *ngIf="featureInputSearch"
          [service]="service"
          (itemEmit)="searchTags($event)"
          (indexIdEmit)="indexId"
          (paramsRouterEmit)="paramsRouterFromSearch">
        </app-input-search>
        <div class="dnd-input" *ngIf="!featureInputSearch">
          <input type="text" class="dnd-input-control" id="dnd-search" name="dnd-search" placeholder="Busca"
            autocomplete="off" [formControl]="requestForm"
            (change)="searchInput()"
            (keydown.enter)="noRefreshSearch()"
            (keydown)="downList($event)">
          <button class="btn-search" (click)="searchText()">
            <img src="../../assets/svgs/search.svg" alt="search">
          </button>
        </div>  
        <div class="element">
          <ul class="select" *ngIf="flagInput && listSearch.length > 1">
            <li *ngFor="let item of listSearch; let i = index" [ngClass]="{'downRow': indexId === i }" (pointerover)="pointerSelection(i)">
              <a (click)="searchTags(item)" id="list-tags-{{i}}">
                <span class="select-description" [innerHTML]="item.label"></span>
                <p>{{ item.type }}</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="dnd-itens-filter">
        <button id="dnd-filter-btn" class="btn-filter" (click)="showFilterAction()" *ngIf="!isSelect">
          <img src="../../assets/svgs/funnel.svg" alt="Funnel Inativo" *ngIf="!showFilter">
          <img src="../../assets/svgs/funnel_act.svg" alt="Funnel Ativo" *ngIf="showFilter">
        </button>
        <img class="dnd-dot-alert" src="../../assets/svgs/dot-alert.svg" alt="Alert" *ngIf="validatorDot() && !isSelect">
        <button id="dnd-display-mode-btn" class="btn-filter mr" (click)="changeView()" *ngIf="!isSelect">
          <img *ngIf="!openList" src="../../assets/svgs/i_open_active.svg" alt="Lista Ativa">
          <img *ngIf="openList" src="../../assets/svgs/i_open.svg" alt="Lista Inativa">
        </button>

        <button 
          class="btn-options"
          [ngClass]="{'open-modal': rowDown}"
          [matMenuTriggerFor]="beforeMenu"
          (click)="rowDown = !rowDown"
          *ngIf="isSelect">
          <span class="btn-text">Ações</span>
          <img src="../../assets/svgs/arrow_down.svg" alt="Icon">
        </button>
        <mat-menu #beforeMenu="matMenu" xPosition="after">
          <button mat-menu-item id="transfer-facs" *ngIf="isLeader" (click)="showTransferModal = true">Transferir</button>
          <button mat-menu-item id="discard-facs" (click)="showBulkDiscard()">Descartar</button>
            <button mat-menu-item id="to-file-facs" *ngIf="!showToFileButton" (click)="showBulkArchiveModal()">Arquivar </button>
            <div *ngIf="featureUnarchiveFac">
              <button mat-menu-item id="unarchive-facs" *ngIf="showToFileButton" (click)="unarchiveSelectedFacs()">Desarquivar</button>
            </div>
        </mat-menu>
      </div>
    </div>
  </div>

  <!-- LIST-TAGS -->
  <div class='tags-content-list'>
    <app-content-scrollable>
      <ul #childComponent class="enable-swipe tags-list" *ngIf="tags.length">
        <li class="tags-item" *ngFor="let tag of tags; let i = index">
          <a class="tags-action" id="tags-{{tag.name}}">
            <p>{{ tag.type }}: {{ tag.description }}</p>
            <button id="remove-tag-btn-{{i}}" class="btn-clear-tag" (click)="removeTags(tag.value, i)">
              <img src="../../assets/svgs/i_clear.svg" alt="Deletar tag">
            </button>
          </a>
        </li>
      </ul>
    </app-content-scrollable>
  </div>
</div>

<!-- V2 -->
<div class="scroll">
  <div class="dnd-template container" #arrow_scroll *ngIf="!openList">
    
    <!-- SEM ATENDIMENTO -->
    <div class="dnd-container">
      <div class="dnd-title dtd">
        <p *ngIf="listDashboard[0].title.length">{{ listDashboard[0].title }} ({{ stageResponse[0].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list dnd-dot"
        #semAtendimentosList="cdkDropList"
        [cdkDropListData]="listDashboard[0].facs"
        [cdkDropListConnectedTo]="[
          semContatoList,
          atendimentoList,
          visitaList,
          poprostaList,
          vendaList
        ]"
        (cdkDropListDropped)="drop($event, {value: 'Sem Atendimento', 'sub_items': []})"
        (scroll)="scroll($event, 0)"
        (mouseover)="getPosition(0)">
        <app-dnd-card
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[0].facs"
          [cdkDragDisabled]="isDrag"
          [ngClass]="{'cdg': !isDrag}"
          [item]="item"
          [feature]="featureTable"
          (sendFavorite)="updateFavorite($event)"
          (openModal)="openModal({event: $event, column: {value: 'Sem Atendimento', 'sub_items': []} })"
          (sendDrag)="eventDrag($event)"
          [isLeader]="isLeader"
        ></app-dnd-card>
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader" style="margin-bottom: 10px;">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[0]">
          <lib-loading></lib-loading>
        </div>
      </div>
    </div>
  
    <!-- SEM CONTATO -->
    <div class="dnd-container">
      <div class="dnd-title">
        <p *ngIf="listDashboard[1].title.length">{{ listDashboard[1].title }} ({{ stageResponse[1].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        #semContatoList="cdkDropList"
        [cdkDropListData]="listDashboard[1].facs"
        [cdkDropListConnectedTo]="[atendimentoList, visitaList, poprostaList, vendaList]"  
        (cdkDropListDropped)="drop($event, {value: 'Sem Contato', 'sub_items': []})" 
        (scroll)="scroll($event, 1)"
        (mouseover)="getPosition(1)">
        <app-dnd-card 
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[1].facs" 
          [cdkDragDisabled]="isDrag"
          [ngClass]="{'cdg': !isDrag}"
          [item]="item"
          [feature]="featureTable"
          (sendFavorite)="updateFavorite($event)"
          (openModal)="openModal({event: $event, column: {value: 'Sem Contato', 'sub_items': []} })"
          (sendDrag)="eventDrag($event)"
          [isLeader]="isLeader"
          ></app-dnd-card>
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[1]">
          <lib-loading></lib-loading>
        </div>   
      </div>
    </div>
  
    <!-- EM ATENDIMENTO -->
    <div class="dnd-container">
      <div class="dnd-title">
        <p *ngIf="listDashboard[2].title.length">{{ listDashboard[2].title }} ({{ stageResponse[2].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        #atendimentoList="cdkDropList"
        [cdkDropListData]="listDashboard[2].facs"
        [cdkDropListConnectedTo]="[semContatoList, visitaList, poprostaList, vendaList]"
        (cdkDropListDropped)="drop($event, {value: 'Em Atendimento', 'sub_items': []})"
        (scroll)="scroll($event, 2)"
        (mouseover)="getPosition(2)">
        <app-dnd-card 
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[2].facs"
          [ngClass]="{'cdg': !isDrag}"
          [cdkDragDisabled]="isDrag" 
          [item]="item"
          [feature]="featureTable"
          (sendFavorite)="updateFavorite($event)"        
          (openModal)="openModal({event: $event, column: {value: 'Em Atendimento', 'sub_items': item.funnel_stage.sub_items} })"
          (sendDrag)="eventDrag($event)"
          [isLeader]="isLeader"
        ></app-dnd-card>
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader" style="margin-bottom: 10px;">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[2]">
          <lib-loading></lib-loading>
        </div>
      </div>
    </div>
  
    <!-- VISITAS -->
    <div class="dnd-container">
      <div class="dnd-title">
        <p *ngIf="listDashboard[3].title.length">{{ listDashboard[3].title }} ({{ stageResponse[3].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        #visitaList="cdkDropList"
        [cdkDropListData]="listDashboard[3].facs"
        [cdkDropListConnectedTo]="[semContatoList, atendimentoList, poprostaList, vendaList]"
        (cdkDropListDropped)="drop($event, {value: 'Visita', 'sub_items': []})"
        (scroll)="scroll($event, 3)"
        (mouseover)="getPosition(3)">
        <app-dnd-card 
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[3].facs" 
          [ngClass]="{'cdg': !isDrag}"
          [cdkDragDisabled]="isDrag"
          [item]="item"
          [feature]="featureTable"
          (sendDrag)="eventDrag($event)"
          (sendFavorite)="updateFavorite($event)"
          (openModal)="openModal({event: $event, column: {value: 'Visita', 'sub_items': []} })"
          [isLeader]="isLeader"
        ></app-dnd-card>
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[3]">
          <lib-loading></lib-loading>
        </div>
      </div>
    </div>
  
    <!-- PROPOSTA -->
    <div class="dnd-container">
      <div class="dnd-title">
        <p *ngIf="listDashboard[4].title.length">{{ listDashboard[4].title }} ({{ stageResponse[4].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        #poprostaList="cdkDropList"
        [cdkDropListData]="listDashboard[4].facs"
        [cdkDropListConnectedTo]="[
          semContatoList, 
          atendimentoList,
          visitaList,
          vendaList
        ]"
        (cdkDropListDropped)="drop($event, {value: 'Proposta', 'sub_items': []})"
        (scroll)="scroll($event, 4)"
        (mouseover)="getPosition(4)">
        <app-dnd-card
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[4].facs"
          [ngClass]="{'cdg': !isDrag}"
          [cdkDragDisabled]="isDrag"
          [item]="item"
          [feature]="featureTable"
          (sendFavorite)="updateFavorite($event)"
          (openModal)="openModal({event: $event, column: {value: 'Proposta', 'sub_items': []} })"
          (sendDrag)="eventDrag($event)"
          [isLeader]="isLeader"
        ></app-dnd-card>  
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader" style="margin-bottom: 10px;">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[4]">
          <lib-loading></lib-loading>
        </div>
      </div>
    </div>
  
    <!-- VENDA -->
    <div class="dnd-container">
      <div class="dnd-title">
        <p *ngIf="listDashboard[5].title.length">{{ listDashboard[5].title }} ({{ stageResponse[5].total_items }})</p>
      </div>
      <div
        cdkDropList
        class="dnd-list"
        #vendaList="cdkDropList"
        [cdkDropListData]="listDashboard[5].facs"
        [cdkDropListConnectedTo]="[
          poprostaList,
          semContatoList, 
          atendimentoList,
          visitaList
          ]"
        (cdkDropListDropped)="drop($event, {value: 'Venda', 'sub_items': []})"
        (scroll)="scroll($event, 5)"
        (mouseover)="getPosition(5)">
        <app-dnd-card 
          class="dnd-box"
          cdkDrag
          *ngFor="let item of listDashboard[5].facs"
          [ngClass]="{'cdg': !isDrag}"
          [cdkDragDisabled]="isDrag"
          [item]="item"
          [feature]="featureTable"
          (sendFavorite)="updateFavorite($event)"
          (openModal)="openModal({event: $event, column: {value: 'Venda', 'sub_items': []} })"
          (sendDrag)="eventDrag($event)"
          [isLeader]="isLeader"
        ></app-dnd-card>
        <div class="mrg-top-15" *ngIf="showFacs">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader" style="margin-bottom: 10px;">
          <img src="../../assets/svgs/card-loader.svg" alt="Loader">
        </div>
        <div *ngIf="loaderDash[5]">
          <lib-loading></lib-loading>
        </div>
      </div>
    </div>

    <button class="btn btn-left" (click)="scrollLeft()">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M2.82832 7.00001L7.77832 11.95L6.36432 13.364L0.000320991 7.00001L6.36432 0.636013L7.77832 2.05001L2.82832 7.00001Z" fill="#EB194B"/>
      </svg>
    </button>
    <button class="btn btn-right" (click)="scrollRight()">
      <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.17266 6.99999L0.222656 2.04999L1.63666 0.635986L8.00066 6.99999L1.63666 13.364L0.222656 11.95L5.17266 6.99999Z" fill="#EB194B"/>
      </svg>
    </button>

  </div>
</div>

<div class="table" *ngIf="openList">
  <app-dnd-table [clearOrder]="clearOrder" (openTable)="openModal({event: $event, column: $event.column })" (sendIndex)="getScroll($event)" (selectOptions)="isSelect = $event" (selectedItems)="getFacIds($event)" ></app-dnd-table>
</div> 

<app-edit-fac-modal 
  *ngIf="showModal" 
  [columnType]="dragItem.columnType" 
  [orderCard]="orderCardHorizontal" 
  [facdId]="dragItem.id" 
  [show]="showModal" 
  (closeM)="closeModal()">
</app-edit-fac-modal>

<app-facs-filters 
  *ngIf="showFilter" 
  [formGroup]="form" 
  (emitFilter)="initFormRouter()" 
  (closeModal)="showFilter = false" 
  (resetClick)="resetForm()">
</app-facs-filters>

<app-transfer-popup *ngIf="showTransferModal" (closeModal)="showTransferModal = false" (transferEvent)="transferFac($event)"></app-transfer-popup>

<app-bulk-error-modal *ngIf="showBulkErrorModal" (closeModal)="showBulkErrorModal = false" [errorMessage]="bulkErrorMessage" [bulkErrorItems]="bulkErrorItems"></app-bulk-error-modal>
<app-discard-popup *ngIf="showDiscardPopup" (closeModal)="closeBulkDiscard()" (discartEvent)="discardSelectedFacs($event)"></app-discard-popup>
